export { BaseElement } from './src/base.js';
export { FormAssociated } from './src/form-associated.js';
export { css, adoptStyles } from './src/styles.js';
export { html, reflectBool, getBoolAttr, toKebab } from './src/utils.js';
export { upgradeProperties, emitValueEvents } from './src/component-helpers.js';

export function define(tag, ctor) {
	if (!customElements.get(tag)) customElements.define(tag, ctor);
}
